"use strict";

var _ = require("lodash");

module.exports = /* @ngInject */ function($log) {
  var that = this;
  var rediPlusWindows = [];
  var workspaceRediPlusWindows = [];

  that.add = function(
    rediPlusWindowId,
    sideBySideInstanceId,
    windowType,
    windowName
  ) {
    rediPlusWindows.push({
      rediPlusWindowId: rediPlusWindowId,
      sideBySideInstanceId: sideBySideInstanceId,
      windowType: windowType,
      windowName: windowName
    });
  };

  that.remove = function(rediPlusWindowId) {
    _.remove(rediPlusWindows, function(obj) {
      return obj.rediPlusWindowId === rediPlusWindowId;
    });
  };

  that.getAllWindows = function() {
    return rediPlusWindows;
  };

  that.getSideBySideIdFromWorkspace = function(rediPlusWindowId) {
    return getSideBySideInstanceIdForCollection(
      workspaceRediPlusWindows,
      rediPlusWindowId
    );
  };

  that.getSideBySideInstanceId = function(rediPlusWindowId) {
    return getSideBySideInstanceIdForCollection(
      rediPlusWindows,
      rediPlusWindowId
    );
  };

  function getSideBySideInstanceIdForCollection(collection, rediPlusWindowId) {
    return _.chain(collection)
      .filter(function(window) {
        return window.rediPlusWindowId === rediPlusWindowId;
      })
      .map(function(window) {
        return window.sideBySideInstanceId;
      })
      .first()
      .value();
  }

  that.getRediPlusWindowId = function(sideBySideInstanceId) {
    return _.chain(rediPlusWindows)
      .filter(function(window) {
        return window.sideBySideInstanceId === sideBySideInstanceId;
      })
      .map(function(window) {
        return window.rediPlusWindowId;
      })
      .first()
      .value();
  };

  that.setWorkspaceWindows = function(windows) {
    $log.info(
      "Setting workspace windows. Current rediPlusWindows = " +
        JSON.stringify(rediPlusWindows)
    );
    workspaceRediPlusWindows = windows;
    $log.info(
      "workspace rediPlusWindows = " + JSON.stringify(workspaceRediPlusWindows)
    );
    var overriddenRediPlusWindows = _.map(rediPlusWindows, function(
      rediPlusWindow
    ) {
      return (
        _.find(workspaceRediPlusWindows, function(workspaceWindow) {
          return (
            workspaceWindow.rediPlusWindowId === rediPlusWindow.rediPlusWindowId
          );
        }) || rediPlusWindow
      );
    });
    rediPlusWindows = overriddenRediPlusWindows;
    $log.info("new rediPlusWindows = " + JSON.stringify(rediPlusWindows));
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/repositories/RediPlusWindowRepository.js